import { render, staticRenderFns } from "./page-toggler-layout.vue?vue&type=template&id=1a1ccf7b&scoped=true"
import script from "./page-toggler-layout.vue?vue&type=script&lang=ts"
export * from "./page-toggler-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ccf7b",
  null
  
)

export default component.exports